import { render, staticRenderFns } from "./activitylist.vue?vue&type=template&id=287a25b6&scoped=true"
import script from "./activitylist.vue?vue&type=script&lang=js"
export * from "./activitylist.vue?vue&type=script&lang=js"
import style0 from "./activitylist.vue?vue&type=style&index=0&id=287a25b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287a25b6",
  null
  
)

export default component.exports